import { useMemo } from 'react';

import { useFlightDeckContext } from '@atlassiansox/flight-deck-frontend-client';

import { FD_CLIENT_FETCH_PROPS, type FlightDeckConfig } from '../../../hydrator-config-client';
import { type CreateActivityClient, createActivityClient } from '../../index';

export const useActivityClient: CreateActivityClient = (
	version,
	product,
	logger,
	baseUrl,
	configFetch,
	collabContextId,
) => {
	const { getArtifact } = useFlightDeckContext();

	// `collabContextId` is included in the deps so the client is recreated if
	// it ever changes. In practice it is set once per page load and does not
	// change during a session, so the client is created once and reused for
	// the lifetime of the consumer.
	return useMemo(
		() =>
			createActivityClient(
				version,
				product,
				logger,
				baseUrl,
				// If the rw-client is wrapped in a FD provider, use the provided fetch function
				configFetch ??
					(getArtifact
						? () =>
								getArtifact<FlightDeckConfig>(
									FD_CLIENT_FETCH_PROPS.name,
									FD_CLIENT_FETCH_PROPS.dimensions,
								)
						: undefined),
				collabContextId,
			),
		[version, product, logger, baseUrl, configFetch, getArtifact, collabContextId],
	);
};
